export const ASSOCIATION_LABEL_SORT_KEY = '__ASSOCIATION_LABEL_SORT__';